import React, { useState, useEffect } from 'react';
import { Shorts } from '../../components/Data/boxingShorts';

// Skeleton Loader
const SkeletonCard = () => (
  <div className="animate-pulse bg-white rounded-2xl p-3 shadow-sm">
    <div className="w-full h-[180px] bg-gray-200 rounded-xl" />
    <div className="h-4 bg-gray-200 rounded mt-3 w-3/4 mx-auto" />
  </div>
);

// Image with Blur Effect
const ImageWithBlur = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative w-full h-[180px] flex items-center justify-center bg-gray-100 overflow-hidden rounded-xl">
      {/* Blur Placeholder */}
      <img
        src={src}
        alt="blur"
        className={`absolute inset-0 w-full h-full object-cover blur-xl scale-110 transition-opacity duration-500 ${loaded ? 'opacity-0' : 'opacity-100'}`}
      />

      {/* Main Image */}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        className={`max-h-full max-w-full object-contain transition duration-500 ${loaded ? 'opacity-100' : 'opacity-0'}`}
      />
    </div>
  );
};

const BoxingShorts = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="w-full bg-gradient-to-b from-white to-gray-100 flex justify-center items-center mt-[100px]">
      <div className="max-w-screen-xl w-full flex flex-col">

        <h4 className="font-bold text-2xl md:text-4xl text-left ml-4 pb-4 border-b border-gray-300 my-10">
          <span className='text-red-500'>Boxing</span> Shorts
        </h4>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 px-4">

          {loading
            ? Array.from({ length: 10 }).map((_, i) => <SkeletonCard key={i} />)
            : Shorts.map((item) => {
                const message = `Hi, I'm interested in the following product:\n\nProduct: ${item.Title}\nCategory: ${item.Category}\n\nPlease provide more details.`;
                const whatsappUrl = `https://wa.me/971557711247?text=${encodeURIComponent(message)}`;

                return (
                  <a
                    key={item.id}
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block"
                  >
                    <article className="cursor-pointer group bg-white rounded-2xl p-3 shadow-sm hover:shadow-lg transition duration-300">

                      {/* Optimized Image */}
                      <ImageWithBlur
                        src={`${process.env.PUBLIC_URL}${item.ImageSource}`}
                        alt={item.Title}
                      />

                      <h3 className="text-sm md:text-base text-gray-800 text-center font-semibold mt-3 group-hover:text-red-500 transition">
                        {item.Title}
                      </h3>

                    </article>
                  </a>
                );
              })}

        </div>
      </div>
    </section>
  );
};

export default BoxingShorts;